import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { PlanVista } from '@/components/planning/ViewModeSelect'
import { buildTimeTrack, type TimeTrack } from '@/utils/planningTimeTracks'

/**
 * Construye el eje temporal del Gantt para la vista y el offset dados.
 *
 * Existe para que la página no tenga que resolver el locale ni pasar `t` a mano:
 * los builders necesitan i18n sólo para las etiquetas del rango.
 */
export function useTimeTrack(vista: PlanVista, offset: number): TimeTrack {
  const { t, i18n } = useTranslation()
  const locale = i18n.resolvedLanguage || 'es'

  return useMemo(
    () => buildTimeTrack(vista, offset, { locale, t }),
    // `t` cambia de identidad al cambiar de idioma, que es justo cuando se deben
    // recalcular las etiquetas.
    [vista, offset, locale, t],
  )
}
